/**
 * Mirror of the server password rules (`_password_problem` in
 * src/auth/routes.py). The server stays authoritative on submit; these only
 * drive the live hints and the submit gate. Shared by the Settings password
 * card and the invite accept page so the two can never disagree.
 */
export function checkLength(pw: string): boolean {
  return pw.length >= 8 && pw.length <= 128;
}

export function checkComposition(pw: string): boolean {
  return /[a-zA-Z]/.test(pw) && /[0-9]/.test(pw);
}
